export default {
  // Fixes webpack issues with NativeVideoModule.VideoThumbnail not existing on web.
  VideoThumbnail: () => {},
};
